import React from 'react';

const LAYERS = [
  { id: 'snn_kg', label: 'Layer 1: SNN Knowledge Graphs', color: '#1976d2' },
  { id: 'cognitive_cortex', label: 'Layer 2: Cognitive Cortex', color: '#7b1fa2' },
  { id: 'process_orchestration', label: 'Layer 3: Process Orchestration', color: '#2e7d32' },
  { id: 'ednl', label: 'EDNL', color: '#ef6c00' },
];

const DemoArchLayer = ({ activeLayers = [] }) => {
  return (
    <div className="demo-arch-layer" style={{
      display: 'flex',
      gap: 8,
      padding: '8px 12px',
      backgroundColor: '#fafafa',
      borderRadius: 4,
      border: '1px solid #eee',
      marginBottom: 12,
    }}>
      <span style={{ fontSize: 11, fontWeight: 600, color: '#666', marginRight: 4, alignSelf: 'center' }}>
        Active:
      </span>
      {LAYERS.map(layer => {
        const isActive = activeLayers.includes(layer.id);
        return (
          <span
            key={layer.id}
            style={{
              display: 'inline-flex',
              alignItems: 'center',
              gap: 4,
              padding: '3px 8px',
              borderRadius: 4,
              fontSize: 11,
              fontWeight: 500,
              backgroundColor: isActive ? layer.color : '#e0e0e0',
              color: isActive ? 'white' : '#9e9e9e',
              opacity: isActive ? 1 : 0.5,
              transition: 'all 0.2s',
            }}
          >
            <span style={{
              width: 6, height: 6, borderRadius: '50%',
              backgroundColor: isActive ? 'rgba(255,255,255,0.8)' : '#bdbdbd',
            }} />
            {layer.label}
          </span>
        );
      })}
    </div>
  );
};

export default DemoArchLayer;
